import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

import { BoldText } from "./BoldText";

export const SectionTitle = ({
    children,
    className,
    ...props
}: ComponentProps<typeof BoldText>) => {
    return (
        <BoldText
            as="h2"
            className={cn("flex items-center", className)}
            {...props}
        >
            {children}
        </BoldText>
    );
};
